/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import './styles/OrderConfirmationPage.scss';

import { ProgressIndicator } from 'sarsaparilla';

import type { Reservation } from './OrderConfirmationPage.types';
import { OrderConfirmationPageConfirmationBox } from './OrderConfirmationPageConfirmationBox';

interface OrderConfirmationPageProps {
    email: string;
    orderID: string;
    reservations: Reservation[];
    subtotal: string;
    tax: string;
    total: string;
    modification: boolean;
}

const steps = ['Order Detail', 'Shopping Cart', 'Payment', 'Confirmation'];

export function OrderConfirmationPage({
    email,
    orderID,
    reservations,
    subtotal,
    tax = '0',
    total,
    modification,
}: OrderConfirmationPageProps) {
    return (
        <div id="page-body" className="rec-order-confirmation-page">
            <section className="rec-order-confirmation-progress-wrap">
                <div className="rec-order-confirmation-progress-row">
                    <div className="rec-grid-12-12">
                        <ProgressIndicator steps={steps} activeStep={4} />
                    </div>
                </div>
            </section>
            <div className="rec-section-outer-wrap">
                <div className="rec-nested-wrap">
                    <div className="rec-page-layout-full-width">
                        <OrderConfirmationPageConfirmationBox
                            email={email}
                            orderID={orderID}
                            reservations={reservations}
                            subtotal={subtotal}
                            tax={tax}
                            total={total}
                            modification={modification}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
